module.exports = __webpack_public_path__ + "static/media/banner_MP_720.b116a014.jpg";